module.exports = __webpack_public_path__ + "img/id-wrong-finger.da59964d.jpg";